<template>
    <a-layout style="min-height: 100vh;">
        <UserHead />
        <a-layout>
            <a-layout-header style="padding: 0; background: #fff; border-bottom: 1px solid #f0f0f0;">
                <HeadTop />
            </a-layout-header>
            <a-layout-content class="carmine-content-div">
                <div class="carmine-table-div">
                    <div class="carmine-title">
                        <span>卡密列表</span>
                    </div>
                    <div class="carmine-toolbar">
                        <a-button type="primary" @click="toAddCarmineDialog">生成卡密</a-button>
                        <a-button @click="toUseCarmine">使用卡密</a-button>
                        <a-button @click="toUseCarmine">验证卡密</a-button>
                    </div>
                    <a-table :data-source="carmineList" :columns="columns" :loading="loading" row-key="id"
                        class="carmine-table" size="middle" :pagination="false">
                        <template #bodyCell="{ column, record }">
                            <template v-if="column.key === 'state'">
                                <a-tag :color="record.state == 1 ? 'success' : 'error'" size="small">
                                    {{ record.state == 1 ? '未使用' : record.state == 0 ? '已使用' : '已禁用' }}
                                </a-tag>
                            </template>
                            <template v-else-if="column.key === 'timeUnit'">
                                {{ getTimeUnit(record.timeUnit) }}
                            </template>
                        </template>
                    </a-table>
                    <div class="carmine-pagination">
                        <a-pagination :current="currentPage" :page-size="pageSize" :total="total"
                            :show-total="(t) => `共 ${t} 条`" show-size-changer :page-size-options="[10, 20, 30, 40]"
                            @change="(page) => handleCurrentChange(page)"
                            @showSizeChange="(cur, size) => handleSizeChange(size)" />
                    </div>
                </div>

                <!-- 生成卡密 -->
                <a-modal v-model:open="addCarmineDialog.isShow" title="生成卡密" width="520px" :mask-closable="false">
                    <a-form :model="addCarmineDialog" layout="vertical">
                        <a-form-item label="选择插件">
                            <a-select v-model:value="addCarmineDialog.plugin"
                                @change="getTimeMealAndVersions(addCarmineDialog.plugin)" placeholder="请选择插件">
                                <a-select-option v-for="(item) in addCarmineDialog.includes_list"
                                    :key="item.includes_id" :value="item.includes_id">
                                    {{ item.includes_id }}---{{ item.includes_name }}---{{ item.grade_name }}
                                </a-select-option>
                                <a-select-option v-if="addCarmineDialog.includes_list.length == 0" disabled>
                                    --暂无插件/您不是任何插件的代理--
                                </a-select-option>
                            </a-select>
                        </a-form-item>

                        <!-- 版本选择 -->
                        <a-form-item label="选择版本" v-if="addCarmineDialog.version_list.length > 1">
                            <a-select v-model:value="addCarmineDialog.version"
                                @change="getTimeMeal(addCarmineDialog.plugin)" placeholder="请选择版本">
                                <a-select-option v-for="item in addCarmineDialog.version_list"
                                    :key="'version_select_' + item.version" :value="item.version">
                                    {{ item.name }}
                                </a-select-option>
                            </a-select>
                        </a-form-item>

                        <a-form-item label="选择时长类型">
                            <a-select v-model:value="addCarmineDialog.time" @change="setTimeMeal(addCarmineDialog.time)"
                                placeholder="请选择时长单位">
                                <a-select-option v-for="(item) in addCarmineDialog.time_meal_list" :key="item.meal_id"
                                    :value="item.meal_id">
                                    {{ item.time_unit }}---{{ item.price }}元
                                </a-select-option>
                            </a-select>
                        </a-form-item>
                        <a-form-item label="卡密数量">
                            <a-input-number v-model:value="addCarmineDialog.num" :min="1" placeholder="请输入卡密数量" />
                        </a-form-item>
                        <a-form-item label="共计">
                            <span class="money-total">{{ (addCarmineDialog.price * addCarmineDialog.num).toFixed(2)
                            }}元</span>
                        </a-form-item>
                    </a-form>
                    <template #footer>
                        <a-button @click="addCarmineDialog.isShow = false">取消</a-button>
                        <a-button type="primary" @click="addCarmineConfirm()">生成</a-button>
                    </template>
                </a-modal>

                <!-- 卡密详情 -->
                <a-modal v-model:open="showCarmineDialog.isShow" title="卡密详情" width="500px" :mask-closable="false">
                    <div class="show-carmine-div">
                        <div class="show-carmine-tip">以下是您的卡密信息：</div>
                        <div v-for="(item, i) in showCarmineDialog.list" :key="i" class="show-carmine-item">
                            {{ item }}
                        </div>
                    </div>
                    <template #footer>
                        <a-button type="primary" @click="showCarmineDialog.isShow = false">确定</a-button>
                    </template>
                </a-modal>
            </a-layout-content>
        </a-layout>
    </a-layout>
</template>
<script>
import { defineComponent } from 'vue';
import UserHead from '@/components/UserHead.vue';
import HeadTop from '@/components/UserHeadTop.vue';
import { message, Modal } from 'ant-design-vue'
import { openLoading, fullscreenLoading } from '@/utils/loadingUtils'
import axios from 'axios';
import router from '@/router';
const baseURL = process.env.VUE_APP_API_BASE_URL;
export default defineComponent({
    components: {
        UserHead,
        HeadTop
    },
    data() {
        return {
            carmineList: [],
            loading: false,
            currentPage: 1,
            pageSize: 10,
            total: 0,
            columns: [
                { title: 'ID', dataIndex: 'id', key: 'id', width: 80 },
                { title: '卡密', dataIndex: 'carmine', key: 'carmine', width: 220 },
                { title: '状态', key: 'state', width: 100 },
                { title: '使用者UID', dataIndex: 'usedUid', key: 'usedUid' },
                { title: '使用时间', dataIndex: 'usedTime', key: 'usedTime', width: 180 },
                { title: '类型', key: 'timeUnit', width: 90 },
                { title: '插件', dataIndex: 'pluginName', key: 'pluginName' },
                { title: '插件版本', dataIndex: 'versionName', key: 'versionName' },
            ],
            addCarmineDialog: {
                isShow: false,
                plugin: '',
                time: '',
                num: 1,
                price: 0.0,
                version: 1,
                includes_list: [],
                time_meal_list: [],
                version_list: []
            },
            showCarmineDialog: {
                isShow: false,
                list: []
            }
        };
    },
    methods: {
        fetchCarmineList() {
            this.loading = true
            axios.post(baseURL + '/carmine/list',
                {
                    currentPage: this.currentPage,
                    pageSize: this.pageSize
                }, {
                timeout: 10000,
                headers: {
                    'token': localStorage.getItem("token")
                }
            }).then(response => {
                this.loading = false
                if (response.data.code == 200) {
                    this.carmineList = response.data.data.list;
                    this.total = response.data.data.total;
                } else if (response.data.code == 401) {
                    message.error(response.data.msg)
                    setTimeout(() => {
                        location.href = "/Login"
                    }, 1000);
                } else {
                    message.error(response.data.msg)
                }
            }).catch(error => {
                this.loading = false
                console.error('获取卡密列表失败:', error);
                message.error('获取卡密列表失败')
            });
        },
        getTimeMealAndVersions(includes_id) {
            openLoading()
            const headers = {
                'token': localStorage.getItem("token")
            }
            var data = new FormData()
            data.append("includes_id", includes_id)
            axios.post(baseURL + "/userApi/getGradeTimeMeal", data, { timeout: 30000, headers: headers })
                .then(res => {
                    fullscreenLoading.close()
                    if (res.data.code == 401) {
                        message.error('您没有登录')
                        setTimeout(() => {
                            location.href = "/Login"
                        }, 1000);
                        return
                    }
                    else if (res.data.code == 200) {
                        const versions_data = res.data.data.data;

                        this.addCarmineDialog.version_list = []
                        this.addCarmineDialog.version = 1

                        versions_data.forEach((version_item) => {
                            const version_name = version_item.version_name || `版本 ${version_item.version}`;

                            this.addCarmineDialog.version_list.push({
                                name: version_name,
                                version: version_item.version,
                                desc: version_item.version_desc || '',
                                meals: version_item.grade_arr
                            });
                        });
                        this.getTimeMeal(includes_id)
                    }
                    else {
                        message.error(res.data.msg)
                    }
                })
                .catch(err => {
                    fullscreenLoading.close()
                    console.log(err)
                    message.error('获取版本和价格信息失败：' + err.message)
                })
        },
        handleSizeChange(val) {
            this.pageSize = val;
            this.currentPage = 1;
            this.fetchCarmineList();
        },
        handleCurrentChange(val) {
            this.currentPage = val;
            this.fetchCarmineList();
        }, toUseCarmine() {
            router.push('/CarmineUse');
        },
        getTimeUnit(type) {
            if (type == 'day') {
                return '天'
            } else if (type == 'month') {
                return '月'
            } else if (type == 'year') {
                return '年'
            } else if (type == 'forever') {
                return '永久'
            }
            else {
                return '未知'
            }
        },
        toAddCarmineDialog() {
            this.addCarmineDialog.isShow = true;
            this.getIncludesList()
        },
        getIncludesList() {
            openLoading()
            const headers = {
                'token': localStorage.getItem("token")
            }
            var data = new FormData()
            data.append("act", 'getEmpowerIncludesList')
            axios.post(baseURL + "/userApi/getIncludesAgent", data, { timeout: 30000, headers: headers })
                .then(res => {
                    fullscreenLoading.close()
                    if (res.data.code == 401) {
                        message.error(res.data.msg)
                        setTimeout(() => {
                            location.href = "/Login"
                        }, 1000);
                        return
                    }
                    else if (res.data.code == 200) {
                        this.addCarmineDialog.includes_list = res.data.data;
                    }
                    else {
                        message.error(res.data.msg)
                    }
                })
                .catch(err => {
                    fullscreenLoading.close()
                    console.log(err)
                    message.error('获取代理插件列表失败：' + err.message)
                })
        }, getTimeMeal(includes_id) {
            openLoading()
            const data = new FormData();
            const headers = {
                'token': localStorage.getItem("token")
            }
            data.append("includes_id", includes_id)
            data.append("version", this.addCarmineDialog.version)
            data.append("act", "getTimeMeal")
            axios.post(baseURL + "/userApi/getInfo", data, { timeout: 30000, headers: headers })
                .then(res => {
                    fullscreenLoading.close()
                    if (res.data.code == 401) {
                        message.error('您没有登录')
                        setTimeout(() => {
                            location.href = "/Login"
                        }, 1000);
                    }
                    else if (res.data.code == 200) {
                        this.addCarmineDialog.time_meal_list = res.data.data
                    }
                    else {
                        message.error(res.data.msg)
                    }
                })
                .catch(err => {
                    fullscreenLoading.close()
                    console.log(err)
                    message.error('请求失败：' + err.message)
                })
        },
        setTimeMeal(time) {
            var element = this.addCarmineDialog.time_meal_list.filter(item => item.meal_id == time);
            this.addCarmineDialog.num = 1
            this.addCarmineDialog.price = element[0].price
        }, addCarmine() {
            openLoading();
            const headers = {
                'token': localStorage.getItem("token")
            };
            axios.post(baseURL + "/carmine/add", {
                pluginId: this.addCarmineDialog.plugin,
                mealId: this.addCarmineDialog.time,
                num: this.addCarmineDialog.num,
                version: this.addCarmineDialog.version
            }, { timeout: 10000, headers: headers })
                .then(res => {
                    fullscreenLoading.close()
                    if (res.data.code == 401) {
                        message.error('您没有登录')
                        setTimeout(() => {
                            location.href = "/Login"
                        }, 1000);
                    }
                    else if (res.data.code == 200) {
                        this.showCarmineDialog.isShow = true;
                        this.addCarmineDialog.isShow = false;
                        this.showCarmineDialog.list = res.data.data.list
                    }
                    else {
                        message.error(res.data.msg)
                    }
                })
                .catch(err => {
                    fullscreenLoading.close()
                    console.log(err)
                    message.error('请求失败：' + err.message)
                })
        },
        addCarmineConfirm() {
            Modal.confirm({
                title: '确认生成卡密？',
                okText: '确定',
                cancelText: '关闭',
                onOk: () => {
                    this.addCarmine();
                },
            })
        }
    },
    created() {
        this.fetchCarmineList();
    }
})
</script>
<style scoped lang="scss">
.carmine-content-div {
    height: 100vh;
    background-color: #f2f3f5 !important;
    overflow-y: auto;
}

.carmine-table-div {
    background-color: white;
    padding: 2rem;
    margin: 1.5rem;
    border-radius: 0.75rem;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
}

.carmine-title {
    font-size: 1.2rem;
    font-weight: 600;
    color: #333;
    margin-bottom: 1.25rem;
    padding-bottom: 0.75rem;
    border-bottom: 2px solid #2563eb;
    display: flex;
    align-items: center;
    justify-content: space-between;
}

.carmine-toolbar {
    display: flex;
    gap: 0.5rem;
    margin-bottom: 1rem;
}

.carmine-table {
    width: 100%;
}

.carmine-pagination {
    display: flex;
    justify-content: center;
    margin-top: 1.5rem;

    :deep(.ant-pagination-item-active) {
        background: linear-gradient(135deg, #2563eb, #3b82f6);
        border-color: transparent;

        a {
            color: #fff;
        }
    }
}

.show-carmine-div {
    background-color: #0f172a;
    color: #e2e8f0;
    overflow: auto;
    padding: 1.25rem;
    border-radius: 0.5rem;
    max-height: 60vh;
}

.show-carmine-tip {
    color: #94a3b8;
    font-size: 0.9rem;
    margin-bottom: 0.75rem;
}

.show-carmine-item {
    font-family: monospace;
    font-size: 0.9rem;
    line-height: 1.8;
    word-break: break-all;
}

.money-total {
    font-size: 1.1rem;
    font-weight: 700;
    color: #d97706;
}

@media screen and (max-width: 768px) {
    .carmine-table-div {
        margin: 1rem;
        padding: 1.2rem;
    }
}
</style>
